
<div class="flow-error-state-wrapper" :position="position">
	<div class="flow-error-state-icon-wrapper">
		<Icon :name="icon.name" :type="icon.type" size="large" :state="icon.state" :effects="false" />
	</div>
	<h3 v-if="message" class="fc-dark fw-normal flow-error-state-messsage text-wrap">
		{{ message }}
	</h3>
	<slot />
</div>
